<div class="gb-hero-outer">
  <span class="gb-orb gb-orb1"></span>
  <span class="gb-orb gb-orb2"></span>
  <span class="gb-orb gb-orb3"></span>
  <div class="gb-wrap">
   
  

    <div class="gb-hero-grid">
      <div class="gb-hero-copy">
        <p class="gb-eyebrow" style="color:var(--sh-g);">GCSE Bootcamp</p>
        <h1 class="gb-hero-title">Walk into the exam hall<span class="gb-brk"></span><span class="gb-grad">already knowing you've passed.</span></h1>
        <p class="gb-hero-sub">A full-syllabus revision bootcamp built around one goal: turning what students already know into marks on the page. Live classes, exam-board-aligned technique, and small batches — from now until results day.</p>
        <div class="gb-hero-ctas">
          <a href="#enrol" class="gb-btn gb-btn-primary"><i class="ti ti-calendar-event"></i> Reserve a Seat</a>
          <a href="#inside" class="gb-btn gb-btn-ghost">See what's inside</a>
        </div>
        <div class="gb-mini-stats">
          <div class="gb-mini-stat" *ngFor="let stat of miniStats">
            <b>{{ stat.value }}</b>
            <span>{{ stat.label }}</span>
          </div>
        </div>
      </div>

      <div class="gb-booklet-hold">
        <div class="gb-booklet">
          <span class="gb-tick-badge"><i class="ti ti-check"></i></span>
          <div class="gb-booklet-head">
            <p class="gb-booklet-tag">Candidate Answer Booklet</p>
            <p class="gb-booklet-title">GCSE Bootcamp — Enrollment</p>
            <div class="gb-field-row">
              <span class="gb-field-label">Tier</span>
              <span style="color:var(--sh-tx);font-weight:700;">Foundation / Higher</span>
            </div>
            <div class="gb-field-row">
              <span class="gb-field-label">Board</span>
              <span style="color:var(--sh-tx);font-weight:700;">AQA · Edexcel · OCR</span>
            </div>
            <div class="gb-field-row">
              <span class="gb-field-label">Batch size</span>
              <div class="gb-field-boxes"><span></span><span></span><span></span></div>
              <span style="color:var(--sh-mu);font-size:12.5px;margin-left:4px;">kept small</span>
            </div>
          </div>
          <div class="gb-booklet-body">
            <p class="gb-booklet-line">"Cover the full spec. Drill the hard topics.<br>Learn the mark scheme's language."</p>
          </div>
          <div class="gb-booklet-stamp">GRADE 9 TRACK</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="gb-trust">
  <div class="gb-marquee">
    <div class="gb-trust-item" *ngFor="let item of trustItemsLoop">
      <i class="ti" [ngClass]="item.icon"></i> {{ item.text }}
    </div>
  </div>
</div>

<section class="gb-section" id="inside">
  <div class="gb-wrap">
    <p class="gb-eyebrow gb-reveal">What's inside</p>
    <h2 class="gb-h2 gb-reveal">Everything between "revised" and "ready."</h2>
    <p class="gb-lede gb-reveal">Four things happen every week of the bootcamp: the syllabus gets covered, technique gets drilled, homework locks it in, and we tell you exactly how it's going.</p>

    <div class="gb-pillars gb-stagger">
      <div class="gb-pillar" *ngFor="let pillar of pillars" [ngClass]="pillar.colorClass">
        <span class="gb-pillar-num">{{ pillar.num }}</span>
        <span class="gb-pillar-tag">{{ pillar.tag }}</span>
        <div class="gb-pillar-icon"><i class="ti" [ngClass]="pillar.icon"></i></div>
        <h3>{{ pillar.title }}</h3>
        <ul>
          <li *ngFor="let point of pillar.points">{{ point }}</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="gb-section gb-ptm">
  <div class="gb-wrap">
    <div class="gb-ptm-grid">
      <div class="gb-reveal">
        <p class="gb-eyebrow">Parents, kept in the loop</p>
        <h2 class="gb-h2">Not a black box. A running conversation.</h2>
        <p class="gb-lede">Grades improve faster when parents aren't guessing. Every bootcamp includes regular Parent-Teacher Meetings — not a generic update, but a real look at where your child stands and what happens next.</p>
      </div>
      <div class="gb-ptm-visual gb-reveal">
        <div class="gb-ptm-row" *ngFor="let item of ptmItems">
          <div class="gb-ptm-ic"><i class="ti" [ngClass]="item.icon"></i></div>
          <div>
            <strong>{{ item.title }}</strong>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="gb-section" style="padding-top:0;">
  <div class="gb-wrap">
    <p class="gb-eyebrow gb-reveal">The outcome</p>
    <h2 class="gb-h2 gb-reveal">Confidence, not just content.</h2>
    <p class="gb-lede gb-reveal" style="margin-bottom:44px;">The point of all this isn't just covering topics — it's walking into the exam hall calm, prepared, and clear on exactly how to turn revision into marks.</p>
    <div class="gb-groups gb-stagger">
      <div class="gb-card" *ngFor="let card of outcomeCards">
        <div class="gb-card-icon"><i class="ti" [ngClass]="card.icon"></i></div>
        <h3>{{ card.title }}</h3>
        <ul>
          <li *ngFor="let point of card.points">{{ point }}</li>
        </ul>
      </div>
    </div>
  </div>
</section>

<section class="gb-section" id="enrol" style="padding-top:0;">
  <div class="gb-wrap">
    <div class="gb-final gb-reveal">
      <h2>Seats are kept deliberately small.</h2>
      <p>Reserve your child's place in the next GCSE Bootcamp batch before it fills.</p>
      <div class="gb-final-ctas">
        <a href="#" class="gb-btn gb-btn-primary"><i class="ti ti-calendar-event"></i> Reserve a Seat</a>
        <a href="#" class="gb-btn gb-btn-ghost"><i class="ti ti-phone"></i> Talk to Us</a>
      </div>
    </div>
  </div>
</section>

<footer>
  Sehyog Academy · GCSE Bootcamp
</footer>

<div class="gb-sticky-cta">
  <a href="#enrol" class="gb-btn gb-btn-primary"><i class="ti ti-calendar-event"></i> Reserve a Seat</a>
</div>
